import { render, staticRenderFns } from "./Beauty.vue?vue&type=template&id=56fcdfe7&scoped=true"
import script from "./Beauty.vue?vue&type=script&lang=js"
export * from "./Beauty.vue?vue&type=script&lang=js"
import style0 from "./Beauty.vue?vue&type=style&index=0&id=56fcdfe7&prod&scoped=true&lang=css"
import style1 from "./Beauty.vue?vue&type=style&index=1&id=56fcdfe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcdfe7",
  null
  
)

export default component.exports